import { useQuery } from 'react-query'
import { getUsers } from 'services/cm-api/get-users'

export function useUsers(customerId) {
  return useQuery(['getUsers' + customerId], () => getUsers(customerId), {
    enabled: Boolean(customerId),
  })
}
